import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { UpdateService } from '../../../core/services/update.service';
import { delay } from 'rxjs/operators';
import { Subscription } from 'rxjs';

enum Display {
	NONE = 'none',
	BLOCK = 'block'
}

@Component({
  standalone: false,
	selector: 'app-update-bar',
	templateUrl: './update-bar.component.html',
	styleUrls: [ './update-bar.component.scss' ]
})
export class UpdateBarComponent implements OnInit, OnDestroy {
	private _subscription: Subscription = new Subscription();
	@HostBinding('style.display') display: Display = Display.NONE;
	public isUpdating = false;

	constructor(private readonly updateService: UpdateService) {
	}

	public ngOnInit(): void {
		this.listenForUpdates();
	}

	public ngOnDestroy(): void {
		this._subscription.unsubscribe();
	}

	public async update(): Promise<void> {
		if (this.isUpdating) {
			return;
		}

		this.isUpdating = true;
		try {
			await this.updateService.update();
		} catch (error) {
			this.isUpdating = false;
			console.error('Error during application update:', error);
		}
	}

	public close(): void {
		this.display = Display.NONE;
	}

	private listenForUpdates(): void {
		this._subscription.add(this.updateService.updateAvailable$.pipe(
			delay(this.updateService.delayForShowingUpdateBar)
		).subscribe((updateAvailable: boolean) => {
			if (updateAvailable) {
				this.display = Display.BLOCK;
			}
		}));
	}
}
